export const generateId = (): string => String(Math.floor(Math.random() * 1000000));
